import recentQuarters from './recent-quarters';

export default function currentQuarter() {
  return recentQuarters()[0];
}
